import React, { useEffect, useState } from "react";
import { UserManagementService } from "../../../service/user_management/user_management.service";
import PersonOutlineRoundedIcon from '@mui/icons-material/PersonOutlineRounded';
import { history } from "../../../helper/history";
import { ManageDashboardService } from "../../../service/manage/dashboard/manage_dashboard.service";
import { formFixture } from "../../../pages/manage/hierarchy/FormFixture";
import PageSpinner from "../../../components/common/spinner/PageSpinner";
import CloseIcon from '@mui/icons-material/Close';
import PersonIcon from '@mui/icons-material/Person';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { ParentDashboardService } from "../../../service/manage/dashboard/parent_dashboard.service";

const UserProfile = ({ isMobileView = false }) => {
  const [userName, setUserName] = useState(sessionStorage.getItem("username"));
  const [email, setEmail] = useState(sessionStorage.getItem("email"));
  const [sessionId, setSessionId] = useState(sessionStorage.getItem("manage_user_id"));
  const [table_log_id, setTableLogId] = useState(sessionStorage.getItem("table_log_id"));
  const [isLoading, setIsLoading] = useState(false);
  const [parentDetails, setParentDetails] = useState({ parents: [], status: "loading", message: "Loading" });
  const [userType, setUserType] = useState(sessionStorage.getItem("userType"));

  const getParentDetails = async () => {
    try {
      const response = await ParentDashboardService.getAllParents(sessionStorage.getItem("manage_user_id"));
      if (response && response.success && response.data) {
        if (response.data.parents) {
          setParentDetails({ parents: response.data.parents, message: "Parent details received", status: "success" });
        } else {
          setParentDetails({ parents: [], message: "No parent details received", status: "info" });
        }
      } else {
        setParentDetails({ parents: [], message: "Failed to get parent details", status: "error" });
      }
    } catch {
      setParentDetails({ parents: [], message: "Failed to get parent details", status: "error" });
    }
  };

  const handleViewProfileClick = () => {
    const closeBtn = document.getElementById("kt_quick_user_close");
    if (closeBtn) closeBtn.click();

    setIsLoading(true);
    ManageDashboardService.getContent(
      sessionId,
      table_log_id,
      "registration",
      "owner"
    )
      .then((res) => {
        const formData = res.data && res.data[0];
        if (!formData) return;

        const state = {
          mid: formData.node_mid,
          lg_user_id: formData.lg_user_id,
          lg_user_table_id: formData.lg_user_table_id,
          flg_list_active: formData.flg_list_active,
          privilege_view: formData.privilege_view,
          privilege_edit: formData.privilege_edit,
          privilege_add: 0,
          privilege_delete: 0,
          owner_restriction: 0,
          user_list_restriction: 1,
          form_display_title: formData.form_display_title,
          form_display_order: formData.form_display_order,
          form_list_id: formData.form_list_id,
          breadcrumb: formData.breadcrumb,
          main_table_id: formData.main_table_id,
          breadcrumb2: formData.breadcrumb,
          nodeTitle: formData.tree_main_title,
          node_mid_actual: formData.node_mid_actual,
          path: "profile",
        };

        const componentDetail = formFixture(state).find(
          (item) => formData.form_list_id === item.formListId
        );

        if (componentDetail?.url) {
          history.push({ pathname: componentDetail.url, state: { ...state } });
        }
      })
      .finally(() => setIsLoading(false));
  };

  useEffect(() => {
    const handleStorageChange = (event) => {
      if (event.storageArea !== sessionStorage) return;
      const { key, newValue } = event;
      if (key === "username") setUserName(newValue);
      if (key === "email") setEmail(newValue);
      if (key === "manage_user_id") setSessionId(newValue);
      if (key === "table_log_id") setTableLogId(newValue);
      if (key === "userType") setUserType(newValue);
    };
    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);

  useEffect(() => {
    if (userType === "student") getParentDetails();
  }, [userType]);

  const ProfileBody = (
    <>
      {/* Header */}
      {!isMobileView &&
        <div className="offcanvas-header d-flex align-items-center justify-content-between pb-5">
          <h3 className="font-weight-bold m-0">User Profile</h3>
          <div id="kt_quick_user_close" style={{ cursor: "pointer" }}>
            <CloseIcon style={{ color: "#b5b5b5" }} />
          </div>
        </div>
      }

      {/* Content */}
      <div className="offcanvas-content pr-5 mr-n5">
        {/* Avatar */}
        <div className="d-flex justify-content-center mb-3">
          <img
            src="https://exoedsstrappdev.blob.core.windows.net/image/image%20(1).png"
            alt="avatar"
            style={{ width: 100, height: 100, borderRadius: "50%", objectFit: "cover" }}
          />
        </div>

        {/* Name & Email */}
        <div style={{ textAlign: "center" }}>
          <p style={{ fontWeight: "bold", fontSize: "1rem", marginBottom: "0.2rem" }}>{userName || "N/A"}</p>
          <p style={{ color: "#5a5a5a", fontSize: "0.9rem", marginBottom: "1rem" }}>{email || "N/A"}</p>
        </div>

        {/* Bottom Buttons */}
        <div className="separator separator-dashed mt-3 mb-4"></div>
        <div className="d-flex justify-content-center mb-2">
          <div
            className="d-flex navi-text text-muted text-hover-primary mt-1"
            onClick={handleViewProfileClick}
            style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
          >
            <PersonOutlineRoundedIcon style={{ marginRight: 5 }} />
            <p className="ml-5" style={{ margin: 0 }}>View Profile</p>
          </div>
        </div>
        <div className="separator separator-dashed mt-3 mb-4"></div>

        {userType === "student" && (
          parentDetails.status === "loading" ? (
            <>{parentDetails.message}</>
          ) : parentDetails.status === "info" || parentDetails.status === "error" ? (
            <>{parentDetails.message}</>
          ) : parentDetails.status === "success" && parentDetails.parents.length > 0 ? (
            parentDetails.parents.map((parent, idx) => (
              <div key={idx} style={{ padding: "0 1rem" }}>
                <p style={{ fontWeight: "bold", marginBottom: "0.5rem" }}>Parent Details</p>
                <div style={{ display: "flex", alignItems: "center", marginBottom: "0.4rem" }}>
                  <PersonIcon style={{ fontSize: "1rem", marginRight: 8, color: "#3E3E3E" }} />
                  <span>{`${parent.first_name || "N/A"} ${parent.last_name || "N/A"}`}</span>
                </div>
                <div style={{ display: "flex", alignItems: "center", marginBottom: "0.4rem" }}>
                  <PhoneIphoneIcon style={{ fontSize: "1rem", marginRight: 8, color: "#3E3E3E" }} />
                  <span>{parent.phone_number || "N/A"}</span>
                </div>
                <div style={{ display: "flex", alignItems: "center", marginBottom: "0.8rem" }}>
                  <MailOutlineIcon style={{ fontSize: "1rem", marginRight: 8, color: "#3E3E3E" }} />
                  <span>{parent.email || "N/A"}</span>
                </div>
                <hr style={{ borderColor: "#eee", margin: "1rem 0" }} />
              </div>
            ))
          ) : (
            <>{parentDetails.message}</>
          )
        )}

        {/* Help */}
        <div
          style={{
            backgroundColor: "#FFF7ED",
            borderRadius: 12,
            padding: "1rem",
            margin: "0 1rem",
            textAlign: "center",
          }}
        >
          <HelpOutlineIcon style={{ color: "#FF4C00", fontSize: "2rem" }} />
          <p style={{ color: "#FF4C00", fontWeight: "bold", margin: "0.5rem 0 0.3rem" }}>
            Do you need help ?
          </p>
          <p style={{ color: "#6A5ACD", fontWeight: "bold", marginBottom: 0 }}>
            +94 778 548 796
          </p>
        </div>

        <div className="separator separator-dashed mt-4 mb-4"></div>
        <div className="d-flex justify-content-center">
          <button
            className="btn btn-sm btn-light-primary font-weight-bolder py-2 px-5"
            onClick={UserManagementService.staffLogout}
          >
            Sign Out
          </button>
        </div>
      </div>
    </>
  );

  return (
    <div>
      {isLoading && <PageSpinner id="show" text="Loading, Please wait!" />}

      {isMobileView ? (
       
        <>
          {ProfileBody}
        </>
      ) : (
        <div
          id="kt_quick_user"
          className="offcanvas offcanvas-right p-10"
          style={{ maxWidth: "360px", width: "100%" }}
        >{ProfileBody}</div>
      )}
    </div>
  );
};

export default UserProfile;